'use client';

import Script from 'next/script';

import { getBranchConfig } from './utils';

export const BranchLegacy = () => {
    const config = getBranchConfig();

    const initOptions = {
        ...(config.enableJourneys && { enable_journeys: true }),
        ...(config.debug && { debug: true }),
    };

    return (
        <Script
            id="branch-sdk"
            src={config.branchScriptUrl}
            strategy="afterInteractive"
            onLoad={() => window.branch?.init(config.branchKey, initOptions)}
        />
    );
};
